import styled from 'styled-components';
import { theme } from '@jadwalh/ui';

export const RadioWrapper = styled.div`
  margin-bottom: ${theme.space_size};
  min-height: 20px;

  label {
    display: flex;
    gap: ${theme.space_size};
    font-family: ${theme.fonts.Bold} !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    margin-bottom: 0;
    align-items: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
  }
  input {
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
    flex-shrink: 0;

    &:disabled ~ p {
      color: ${theme.colours.gray5} !important;
    }
  }
  p {
    width: calc(100% - 20px);
  }

  .mantine-Radio-inner {
    align-self: center !important;
  }
  .mantine-Radio-inner {
    svg {
      color: #242424 !important;
    }
  }
  .mantine-Radio-inner {
    input {
      border: 0.5px solid #242424;
      -webkit-appearance: none;
      appearance: none;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      position: relative;
      
      &:checked {
        background-color: white !important;
        border-color: #242424 !important;

        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #242424 !important;
        }
      }
      
      &:not(:checked) {
        background-color: white !important;
      }
    }
  }
`;
